import { Component } from "react";
import PropTypes from "prop-types";

export default class BatchProviders extends Component {
  static propTypes = {
    query: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    children: PropTypes.func.isRequired,
  };

  state = {
    suggestionsForQuery: new Map(),
  };

  componentWillReceiveProps(nextProps) {
    const { query } = this.props;

    if (query !== nextProps.query) {
      this.setState({
        suggestionsForQuery: new Map(),
      });
    }
  }

  handleChange = nextSuggestions => {
    this.setState(
      ({ suggestionsForQuery }) => {
        const { query } = this.props;
        const pastSuggestions = suggestionsForQuery.get(query);

        return {
          suggestionsForQuery: suggestionsForQuery.set(
            query,
            Array.isArray(pastSuggestions) ? pastSuggestions.concat(nextSuggestions) : nextSuggestions,
          ),
        };
      },
      () => {
        const { query, onChange } = this.props;
        const { suggestionsForQuery } = this.state;

        onChange(suggestionsForQuery.get(query));
      },
    );
  };

  render = () => {
    const { query, children } = this.props;

    return children({
      query,
      onChange: this.handleChange,
    });
  };
}
